import * as Actions from '../../actions/coupon/coupon';
import * as QuickActions from '../../actions/coupon/quickbet';
import * as BetSlipsActions from '../../actions/coupon/coupon';
export default function couponAmountReducer(state, action) {
    switch (action.type) {
        case Actions.CHANGE_BET_AMOUNT:
            return action.data;
        case QuickActions.CLOSE_QUICKBET_MODAL:
        case BetSlipsActions.CLOSE_BETSLIP_MODAL:
            return '';
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/coupon/couponAmountReducer.js